import { render, staticRenderFns } from "./topHeader.vue?vue&type=template&id=5703f734&scoped=true"
import script from "./topHeader.vue?vue&type=script&lang=js"
export * from "./topHeader.vue?vue&type=script&lang=js"
import style0 from "./topHeader.vue?vue&type=style&index=0&id=5703f734&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5703f734",
  null
  
)

export default component.exports